// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5b7e4db0","732":"a989c4f4","977":"4eecfcfd"}[chunkId] + ".chunk.js";
};